<template>
    <div v-if="documents && documents.length > 0">
        <d-dms-stamper
            ref      = "stamper"
            @stamped = "onStamped"
        />

        <div class="v-flex">
            <div
                v-if = "verificationDate"
                class="primary mr-1 header-button"
            >
                <v-tooltip
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click = "onMail"
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <v-icon size="20" color="white">mdi-email-send-outline</v-icon>
                        </a>
                    </template>
                    <span>{{  $t('invoice.doc.stamp.send') }}</span>
                </v-tooltip>
            </div>

            <div
                v-if = "verificationDate && admin"
                class="primary header-button"
            >
                <v-tooltip
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            @click = "onReset"
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <v-icon size="20" color="white">mdi-lock-outline</v-icon>
                        </a>
                    </template>
                    <span>{{  $t('invoice.doc.stamp.reset') }}</span>
                </v-tooltip>
            </div>
        </div>

        <v-menu
            top
            offset-y
            content-class = "white"
            nudge-top     = "10"
            v-model       = "showMenu"
            v-if          = "!verificationDate"
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                        <div
                            v-if = "!verificationDate"
                            class="primary header-button"
                        >
                            <a
                                class  = "dialog-button"
                                @click = "onStamp"
                                v-bind = "attrs"
                                v-on="{ ...tooltip, ...menu }"
                            >
                                <v-icon color="white" size="20">mdi-stamper</v-icon>
                            </a>
                        </div>
                    </template>
                    <span>{{  $t('invoice.doc.stamp.execute') }}</span>
                </v-tooltip>
            </template>

            <div
                v-if="this.documents && this.documents.length > 1"
                class="document-content"
            >
                <div
                    class="document-header primary white--text"
                >
                    {{ $t('invoice.doc.header') }}
                </div>

                <v-container class="document-list">
                    <div
                        class="document"
                        v-for="(document, index) in documents" :key="index"
                    >
                        <v-card outlined :ripple = "false" class=" pb-0">
                            <inc-document-link
                                :document =" document"
                                @click    = "onStampDocument(document)"
                            />
                        </v-card>
                    </div>
                </v-container>
            </div>
        </v-menu>
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import DDmsStamper     from "@/modules/dms/stamp/components/DDmsStamper.vue";
import IncDocumentLink from "@/modules/inc/steps/components/invoice/private/IncDocumentLink.vue";

export default {
    name: "PIncInvoiceStampMenu",

    components: {
        DDmsStamper,
        IncDocumentLink
    },

    props: {
        data: {
            required: true,
            type: Object,
        },

        unitId: {
            required: false,
            type: Number,
            default: function () {
                return null;
            }
        },
    },

    data: () => ({
        confirm  : false,
        showMenu : false,
        message: {
            query: null,
            text : null
        },
    }),

    mounted() {
    },

    beforeDestroy() {
    },

    computed: {
        admin() {
            return Core.role.admin();
        },

        verificationDate () {
            return Core.format.date.display(this.data.verficationDate);
        },

        sendDate () {
            return Core.format.date.display(this.data.sendDate);
        },

        incident () {
            return this.$store.getters.incident;
        },

        stepData () {
            if (!this.incident) {
                return null;
            }

            const fileId = this.data.fileId ? this.data.fileId : this.data.id;
            return this.incident.data.find(d => d.id === fileId);
        },

        documents () {
            if (!this.stepData) {
                return null;
            }

            return this.stepData.documents.filter (d => d.type.id === 3);
        },
    },

    methods: {
        /**
         * The mail button was pressed.
         */
        onMail () {
            this.$emit("mail", this.documents.filter(d => d.stamped));
        },

        onReset () {
            Core.message.confirm(
                this,
                this.$t("invoice.doc.reset.query"),
                this.$t("invoice.doc.reset.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.$emit("reset");
                });
        },

        /**
         * The menu stamp button was pressed. If the document is unique, the dialog for stamping is displayed.
         */
        onStamp () {
            if (this.documents.length === 1) {
                this.onStampDocument (this.documents[0])
                this.showMenu = false;
            }
        },

        /**
         * The stamp button in the dialog for stamping was pressed. The stamp process will be performed.
         * @param document the document to stamp.
         */
        onStampDocument (document) {
            this.$refs.stamper.open (document);
            this.showMenu = false;
        },

        /**
         * The selected document was stamped.
         */
        onStamped () {
            this.$emit("stamped");
        },
    }
}
</script>

<style scoped>

.header-button {
    width: 30px;
    text-align: center;
    border-radius: 4px;
    margin-bottom: 1px
}

.document-content {
    width: 400px;
    padding: 5px;
    background-color: white;
}

.document-list {
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;
    background-color: white;
}

.document-header {
    height: 35px;
    padding-left: 10px;
    padding-top: 5px;
    margin: 5px;
    border-radius: 4px;
    font-weight: 500;
}

.document {
    width: 50%;
    height: 120px;
    padding: 5px;
    margin: 0;
    overflow: hidden;
}

</style>